import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FancyGrid from '@sht-dev/fancy-grid';
import { setPage, setPageSize } from './ServiceTypeListSlice';
import { getServiceTypes } from './ServiceTypeListActionCreators';
import { AddButton } from '../../../components/AddButton/AddButton';

const servicesBoxStyle = {
    width: '90%'
}


export const ServiceTypes = () => {
    const dispatch = useDispatch();

    const { serviceTypes, total, pageCount, page, pageSize } = useSelector((state) => state.serviceTypeList);

    useEffect(() => {
        dispatch(getServiceTypes(pageSize, page));
    }, [dispatch, pageSize, page]);

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>
                <div style={{ fontSize: '35px', color: '#153A4B' }}>
                    <p style={{ margin: '15px 15px 15px 0px' }}>Service Types</p>
                </div>
                <AddButton to="/service-types/create-service-type">Create a Service Type</AddButton>
            </div>
            <div style={servicesBoxStyle}>
                <FancyGrid.Grid style={servicesBoxStyle} >
                    <FancyGrid.ColumnList>
                        <FancyGrid.Column
                            name="name"
                            title="Type of Service"
                        />
                    </FancyGrid.ColumnList>
                    <FancyGrid.LocalDataSource data={serviceTypes} />
                    <FancyGrid.Pager
                        count={total}
                        page={page}
                        onPageChange={(e) => dispatch(setPage(e))}
                        numPages={pageCount}
                        pageSize={pageSize}
                        onPageSizeChange={(e) => dispatch(setPageSize(e))}
                    />
                </FancyGrid.Grid>
            </div>
        </div>
    );
};
